<template>
  <gg-card>
    <gg-card-header>
      Manage Parked Domains
      <div class="float-right">
        <gg-text-field
          v-model="search"
          append-icon="mdi-magnify"
          placeholder="Search"
          hide-details
        />
      </div>
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :search="search"
            :loading="loading"
            :headers="headers"
            :items="parkedDomains"
          >
            <template v-slot:item.actions="{ item }">
              <gg-btn @click="openModal('delete', item)">
                Delete
              </gg-btn>
            </template>
          </v-data-table>
        </v-col>
        <delete-alias-modal
          :opened="modals.delete"
          :alias="selectedItem"
          @alias-removed="reload"
          @close="closeModal('delete')"
        />
        <manage-redirection-modal
          :opened="modals.redirection"
          :hosting-domain="selectedItem"
          @redirection-updated="reload"
          @redirection-removed="reload"
          @close="closeModal('redirection')"
        />
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import reloadable from '@/mixins/tableShouldBeReloaded'
import modalsTable from '@/mixins/modalsTable'
import DeleteAliasModal from './DeleteAliasModal'
import ManageRedirectionModal from '../ManageRedirectionModal'

export default {
  name: 'AliasesTable',
  components: {
    DeleteAliasModal,
    ManageRedirectionModal,
  },
  mixins: [reloadable, modalsTable],
  data () {
    return {
      search: '',
      loading: true,
      headers: [
        {
          text: 'Domain',
          value: 'domain',
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false,
        }
      ],
      modals: {
        delete: false,
        redirection: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      parkedDomains: 'hostingDomains/parkedDomains'
    })
  },
  methods: {
    ...mapActions({
      getHostingParkedDomains: 'hostingDomains/getHostingParkedDomains',
      reportError: 'reportError'
    }),
    async reload () {
      this.loading = true
      try {
        await this.getHostingParkedDomains(this.$route.query.user)
        this.loading = false
        this.$emit('table-reloaded')
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    }
  },
  mounted () {
    this.reload()
  }
}
</script>
